import React from 'react';
import {curry} from 'ramda';
import {Link} from 'react-router-dom';
import EditIcon from '@material-ui/icons/Edit';
import {IngestConfigFiltersHandlers} from './IngestConfigTypes';

export const renderEditIcon = curry((location, {id}) => {
    const url = `/ingest-configs-edit/${id}/${location}`;

    return (
        <Link className="edit-icon-link" to={url}>
            <EditIcon />
        </Link>
    );
});

export const getIngestConfigsFilters = (filterHandlers: IngestConfigFiltersHandlers) => {
    const handlePartnersChange = handleFilters({
        ...filterHandlers,
        key: 'contentPartnerId',
    });

    const handleStatusChange = handleFilters({
        ...filterHandlers,
        key: 'status',
    });

    const handleIngestTypeChange = handleFilters({
        ...filterHandlers,
        key: 'ingestType',
    });

    const handleLabPartnerChange = handleFilters({
        ...filterHandlers,
        key: 'labPartner',
    });

    return {
        handlePartnersChange,
        handleStatusChange,
        handleIngestTypeChange,
        handleLabPartnerChange,
    };
};

export const handlePaging = curry((containerArgs, tablePaging) => {
    const {getList, setQuery, history, route, ...containerParams} = containerArgs;

    const params = {
        ...containerParams,
        ...tablePaging,
    };

    setQuery(history, route, params);
    getList(params);
});

export const handleDebounce = curry(({debouncedFunction, setName}, {target}) => {
    const {value} = target;

    setName(value);
    debouncedFunction(value);
});

export const handleDebounceCallback = curry((handlers, name) => {
    const {getList, setPage, setQuery, history, route, ...params} = handlers;
    const newQuery = {
        ...params,
        name,
    };

    setPage(0);
    setQuery(history, route, newQuery);
    getList(newQuery);
});

export const handleFilters = curry((presets, {target: {value}}) => {
    const {
        setFilter,
        setPage,
        setQuery,
        history,
        getList,
        rowsPerPage,
        filters,
        name,
        key,
        route,
    } = presets;

    const newFilters = {
        ...filters,
        [key]: value,
    };
    const query = {
        ...newFilters,
        offset: 0,
        name,
        limit: rowsPerPage,
    };

    setPage(0);
    setQuery(history, route, query);
    setFilter(newFilters);
    getList(query);
});
